import React from 'react';
import { useParams } from 'react-router-dom';

import Layout from '../../../components/layout/Layout';
import EditRate from '../../../components/rate/EditRate';
import AnalyticsWrapper from '../../../components/common/AnalyticsWrapper';

const EditRateView = () => {
  const { id } = useParams();
  return (
    <AnalyticsWrapper>
      <Layout title="Edit rate">
        <EditRate id={id} />
      </Layout>
    </AnalyticsWrapper>
  );
};

export default EditRateView;
